export enum EPlatform {
  MowicoDemo = 36,
  Shopify = 23,
  WooCommerce = 30,
  Ideasoft = 27,
  Prestashop = 21,
  BigCommerce = 7,
}
